import { Stack, TextField } from '@mui/material'
import { EditorField } from './schemaEditorReducer'
import PaduConfig from './PaduConfig'

interface P {
    field: EditorField
    onUpdateField: (
        fieldId: string,
        updates: Partial<EditorField>
    ) => void
}

const DateFieldConfig = ({ field, onUpdateField }: P) => {
    return (
        <Stack spacing={2}>
            <Stack direction='row' spacing={2}>
                <TextField
                    disabled={field.isDefault}
                    fullWidth
                    size='small'
                    type='date'
                    label='From'
                    InputLabelProps={{ shrink: true }}
                    value={field.validation?.fromDate ?? ''}
                    onChange={e =>
                        onUpdateField(field._id, {
                            validation: {
                                fromDate:
                  e.target.value === ''
                      ? undefined
                      : e.target.value
                            }
                        })}
                />

                <TextField
                    disabled={field.isDefault}
                    fullWidth
                    size='small'
                    type='date'
                    label='To'
                    InputLabelProps={{ shrink: true }}
                    value={field.validation?.toDate ?? ''}
                    onChange={e =>
                        onUpdateField(field._id, {
                            validation: {
                                toDate:
                  e.target.value === null
                      ? undefined
                      : e.target.value
                            }
                        })}
                />
            </Stack>
            <PaduConfig
                field={field}
                onUpdateField={onUpdateField}
            />
        </Stack>
    )
}

export default DateFieldConfig
